<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body" v-if="!loading && tableData[0]">
            <div class="row mt-2">
              <div class="col-sm-3 text-center">
                <h5 class="text-danger mb-2">Total {{ $t("dashboards.user") }}</h5>
                <h2>
                  <b>{{ total_users }}</b>
                </h2>
              </div>
              <div class="col-sm-3 text-center">
                <h5 class="text-purple mb-2">Total Admin</h5>
                <h2>
                  <b>{{ total_admin }}</b>
                </h2>
              </div>
              <div class="col-sm-3 text-center">
                <h5 class="text-info mb-2">Total {{ $t("dashboards.analyst") }}</h5>
                <h2>
                  <b>{{ total_analys }}</b>
                </h2>
              </div>
              <div class="col-sm-3 text-center">
                <h5 class="text-success mb-2">Total {{ $t("dashboards.verifier") }}</h5>
                <h2>
                  <b>{{ total_verifikator }}</b>
                </h2>
              </div>
            </div>
          </div>
          <div class="card-body" v-if="loading && !tableData[0]">
            <div class="row">
              <div class="col-12 text-center align-item-center m-5 p-5">
                <div class="spinner-border" role="status">
                  <span class="sr-only">Loading...</span>
                </div>
                <div>
                  <span>Loading..</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body" v-if="!loading && tableData[0]">
            <b-button
              @click="addUserModal"
              variant="success"
              class="btn btn-success btn-sm"
            >
              <i class="mdi mdi-plus mr-1"></i>
              {{ $t("button.add") }} Users</b-button
            >
            <b-modal
              id="modal-add"
              centered
              :title="$t('button.add')"
              title-class="font-18"
              @ok="addUser"
              hide-footer
            >
              <div class="row">
                <div class="col-md-12">
                  <div class="form-group">
                    <label for="validationCustom01">{{
                      $t("user-management.name")
                    }}</label>
                    <input
                      id="validationCustom01"
                      type="text"
                      class="form-control"
                      :placeholder="$t('user-management.name')"
                      v-model="form.user.name"
                      :class="{
                        'is-invalid': submitted && $v.form.user.name.$error,
                      }"
                    />
                    <div
                      v-if="submitted && $v.form.user.name.$error"
                      class="invalid-feedback"
                    >
                      <span v-if="!$v.form.user.name.required">{{
                        $t("form.error.text")
                      }}</span>
                    </div>
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="form-group">
                    <label for="validationCustom02">{{
                      $t("user-management.username")
                    }}</label>
                    <input
                      id="validationCustom01"
                      type="text"
                      class="form-control"
                      :placeholder="$t('user-management.username')"
                      v-model="form.user.username"
                      :class="{
                        'is-invalid': submitted && $v.form.user.username.$error,
                      }"
                    />
                    <div
                      v-if="submitted && $v.form.user.username.$error"
                      class="invalid-feedback"
                    >
                      <span v-if="!$v.form.user.username.required">{{
                        $t("form.error.text")
                      }}</span>
                    </div>
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="form-group">
                    <label for="validationCustom03">{{
                      $t("user-management.email")
                    }}</label>
                    <input
                      id="validationCustom01"
                      type="email"
                      class="form-control"
                      :placeholder="$t('user-management.email')"
                      v-model="form.user.email"
                      :class="{
                        'is-invalid': submitted && $v.form.user.email.$error,
                      }"
                    />
                    <div
                      v-if="submitted && $v.form.user.email.$error"
                      class="invalid-feedback"
                    >
                      <span v-if="!$v.form.user.email.required">{{
                        $t("form.error.text")
                      }}</span>
                    </div>
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="form-group">
                    <label for="validationCustom04">{{
                      $t("user-management.role")
                    }}</label>
                    <select
                      class="custom-select"
                      v-model="form.user.role"
                      :class="{
                        'is-invalid': submitted && $v.form.user.role.$error,
                      }"
                    >
                      <option value="admn">Admin</option>
                      <option value="anly">{{ $t("dashboards.analyst") }}</option>
                      <option value="verf">{{ $t("dashboards.verifier") }}</option>
                    </select>
                    <div
                      v-if="submitted && $v.form.user.role.$error"
                      class="invalid-feedback"
                    >
                      <span v-if="!$v.form.user.role.required">{{
                        $t("form.error.text")
                      }}</span>
                    </div>
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="form-group">
                    <label for="validationCustom05">{{
                      $t("user-management.password")
                    }}</label>
                    <input
                      id="validationCustom01"
                      type="password"
                      class="form-control"
                      :placeholder="$t('user-management.password')"
                      v-model="form.user.password"
                      :class="{
                        'is-invalid': submitted && $v.form.user.password.$error,
                      }"
                    />
                    <div
                      v-if="submitted && $v.form.user.password.$error"
                      class="invalid-feedback"
                    >
                      <span v-if="!$v.form.user.password.required">{{
                        $t("form.error.text")
                      }}</span>
                    </div>
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="text-right">
                    <b-button
                      class="mt-3 mr-1"
                      @click="$bvModal.hide('modal-add')"
                      variant="danger"
                      >{{ $t("button.cancel") }}</b-button
                    >
                    <b-button
                      class="mt-3 mr-1"
                      @click="addUser"
                      variant="success"
                      >{{ $t("button.save") }}</b-button
                    >
                  </div>
                </div>
              </div>
            </b-modal>

            <div class="row mt-4">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    {{ $t("table.show_label") }}&nbsp;&nbsp;
                    <b-form-select
                      v-model="perPage"
                      size="sm"
                      :options="pageOptions"
                      class="mx-1"
                    ></b-form-select
                    >&nbsp;&nbsp;{{ $t("table.entri_label") }}
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div
                  id="tickets-table_filter"
                  class="dataTables_filter text-md-right"
                >
                  <label class="d-inline-flex align-items-center">
                    {{ $t("table.search_label") }}:
                    <b-form-input
                      v-model="filter"
                      type="search"
                      :placeholder="$t('navbar.search.text')"
                      class="form-control form-control-sm ml-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table
                :items="tableData"
                :fields="fields"
                responsive="sm"
                :per-page="perPage"
                :current-page="currentPage"
                :sort-desc.sync="sortDesc"
                :filter="filter"
                :filter-included-fields="filterOn"
                @filtered="onFiltered"
              >
                <template #cell(username)="row">
                  <!-- {{row.item.avatar }} -->
                  <!-- <img
                      src="@/assets/images/users/avatar-10.jpg"
                      class="mr-3 rounded-circle avatar-xs"
                      alt="user-pic"
                    /> -->
                  <img
                    :src="urlImage + row.item.avatar"
                    class="rounded-circle header-profile-user"
                    alt="avatar"
                    v-if="row.item.avatar"
                  />
                  <img
                    src="@/assets/images/users/avatar-10.jpg"
                    class="rounded-circle header-profile-user"
                    alt="avatar"
                    v-else
                  />
                  {{ row.item.username }}
                </template>
                <template #cell(role)="row">
                  <span
                    class="badge badge-secondary p-1 px-1 badge-md rounded"
                    variant="secondary"
                    v-if="row.item.role == 'admn'"
                  >
                    Admin</span
                  >
                  <span
                    class="badge badge-info p-1 px-1 rounded"
                    v-else-if="row.item.role == 'anly'"
                  >
                    {{ $t("dashboards.analyst") }}</span
                  >
                  <span
                    class="badge badge-success p-1 px-1 rounded"
                    v-else-if="row.item.role == 'verf'"
                  >
                    {{ $t("dashboards.verifier") }}</span
                  >
                  <span v-else> {{ row.item.role }}</span>
                </template>
                <template #cell(is_active)="row">
                  <span
                    class="p-1 px-1 text-success"
                    v-if="row.item.is_active == '1'"
                  >
                    <i class="fa fa-check"></i>
                  </span>
                  <span class="p-1 px-1 text-danger" v-else
                    ><i class="fa fa-times"></i
                  ></span>
                </template>
                <template #cell(actions)="row">
                  <router-link
                    :to="{
                      path: '/malware/user/detail',
                      query: { id: getId(row.item.id_user) },
                    }"
                  >
                    <b-button
                      title="Detail"
                      class="btn btn-sm mr-1 mb-1 rounded"
                      variant="success"
                    >
                      <i class="fa fa-eye"></i>
                    </b-button>
                  </router-link>

                  <b-button
                    title="Edit User"
                    @click="
                      editUser(
                        row.item.id_user,
                        row.item.name,
                        row.item.username,
                        row.item.email,
                        row.item.role
                      )
                    "
                    class="btn btn-sm mr-1 mb-1 rounded"
                    variant="info"
                    ><i class="bx bx-pencil"></i
                  ></b-button>
                  <b-modal
                    ref="ref-modal-edit"
                    :id="'modal-edit' + row.item.id_user"
                    centered
                    :title="$t('button.update')"
                    title-class="font-18"
                    hide-footer
                    @ok="updateUser($event, row.item.id_user)"
                  >
                    <div class="row">
                      <div class="col-md-12">
                        <div class="form-group">
                          <label for="validationCustom01">{{
                            $t("user-management.name")
                          }}</label>
                          <input
                            id="validationCustom01"
                            type="text"
                            class="form-control"
                            :placeholder="$t('user-management.name')"
                            v-model="form.user.name"
                            :class="{
                              'is-invalid':
                                submitted && $v.form.user.name.$error,
                            }"
                          />
                          <div
                            v-if="submitted && $v.form.user.name.$error"
                            class="invalid-feedback"
                          >
                            <span v-if="!$v.form.user.name.required">{{
                              $t("form.error.text")
                            }}</span>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-12">
                        <div class="form-group">
                          <label for="validationCustom02">{{
                            $t("user-management.username")
                          }}</label>
                          <input
                            id="validationCustom01"
                            type="text"
                            class="form-control"
                            :placeholder="$t('user-management.username')"
                            v-model="form.user.username"
                            :class="{
                              'is-invalid':
                                submitted && $v.form.user.username.$error,
                            }"
                          />
                          <div
                            v-if="submitted && $v.form.user.username.$error"
                            class="invalid-feedback"
                          >
                            <span v-if="!$v.form.user.username.required">{{
                              $t("form.error.text")
                            }}</span>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-12">
                        <div class="form-group">
                          <label for="validationCustom03">{{
                            $t("user-management.email")
                          }}</label>
                          <input
                            id="validationCustom01"
                            type="email"
                            class="form-control"
                            :placeholder="$t('user-management.email')"
                            v-model="form.user.email"
                            :class="{
                              'is-invalid':
                                submitted && $v.form.user.email.$error,
                            }"
                          />
                          <div
                            v-if="submitted && $v.form.user.email.$error"
                            class="invalid-feedback"
                          >
                            <span v-if="!$v.form.user.email.required">{{
                              $t("form.error.text")
                            }}</span>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-12">
                        <div class="form-group">
                          <label for="validationCustom04">{{
                            $t("user-management.role")
                          }}</label>
                          <select
                            class="custom-select"
                            v-model="form.user.role"
                            :class="{
                              'is-invalid':
                                submitted && $v.form.user.role.$error,
                            }"
                          >
                            <option value="admn">Admin</option>
                            <option value="anly">{{ $t("dashboards.analyst") }}</option>
                            <option value="verf">{{ $t("dashboards.verifier") }}</option>
                          </select>
                          <div
                            v-if="submitted && $v.form.user.role.$error"
                            class="invalid-feedback"
                          >
                            <span v-if="!$v.form.user.role.required">{{
                              $t("form.error.text")
                            }}</span>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-12">
                        <div class="text-right">
                          <b-button
                            class="mt-3 mr-1"
                            @click="
                              $bvModal.hide('modal-edit' + row.item.id_user)
                            "
                            variant="danger"
                            >{{ $t("button.cancel") }}</b-button
                          >
                          <b-button
                            class="mt-3 mr-1"
                            @click="updateUser($event, row.item.id_user)"
                            variant="success"
                            >{{ $t("button.update") }}</b-button
                          >
                        </div>
                      </div>
                    </div>
                  </b-modal>
                  <b-button
                    class="mr-1 btn-sm mb-1 rounded"
                    title="Delete User"
                    variant="danger"
                    @click="deleteUser(row.item.id_user)"
                  >
                    <i class="bx bx-trash"></i>
                  </b-button>
                </template>
              </b-table>
            </div>
            <div class="row" v-if="rows > 10">
              <div class="col-2">
                <!-- <div v-if="selected[0]">
                        <b-button class="btn btn-sm" variant="danger" @click="bulkAction()">Bulk Delete : {{selected.length}} Rows Data</b-button>
                      </div> -->
                <label class="d-inline-flex align-items-center">
                  Page
                  <b-form-input
                    v-model="currentPage"
                    placeholder="Page"
                    class="form-control w-10 form-control ml-2"
                  ></b-form-input>
                </label>
              </div>
              <div class="col-10 text-right" v-if="rows > 10">
                <div
                  class="dataTables_paginate paging_simple_numbers float-right"
                >
                  <ul
                    class="pagination pagination-rounded mb-0"
                    :class="
                      theme == 'dark'
                        ? 'custom-paginate-dark'
                        : 'custom-paginate'
                    "
                  >
                    <!-- pagination -->
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div class="card-body" v-if="loading && !tableData[0]">
            <div class="row">
              <div class="col-12 text-center align-item-center m-5 p-5">
                <div class="spinner-border" role="status">
                  <span class="sr-only">Loading...</span>
                </div>
                <div>
                  <span>Loading..</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import Vue from "vue";
import Swal from "sweetalert2";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { required, sameAs } from "vuelidate/lib/validators";
import UserService from "@/helpers/user.service";
import { userService } from "@/helpers/authservice/user.service";
import moment from "moment";
// import Stat from "@/components/widgets/stat";

export default {
  page: {
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader },
  data() {
    return {
      urlImage: process.env.VUE_APP_BASE_API_URL_AVATAR,
      role: "",
      total_users: 0,
      total_admin: 0,
      total_analys: 0,
      total_verifikator: 0,
      loading: false,
      tableData: [],
      title: this.$t("user-management.user-management"),
      theme: localStorage.getItem("theme") ?? "light",
      items: [
        {
          text: "Dashboard",
          href: "/",
        },
        {
          text: this.$t("user-management.user-management"),
          active: true,
        },
      ],
      statData: [
        {
          icon: "bx bx-user",
          title: "Total User",
          value: "11",
        },
        {
          icon: "bx bx-user",
          title: "Total User",
          value: "11",
        },
        {
          icon: "bx bx-user",
          title: "Total User",
          value: "11",
        },
        {
          icon: "bx bx-user",
          title: "Total User",
          value: "11",
        },
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      sortDesc: false,
      fields: [
        {
          key: "no",
          class: "text-center",
          thStyle: { width: "2%" },
          label: "No",
        },
        { key: "id_user", thClass: "d-none", tdClass: "d-none" },
        {
          key: "username",
          sortable: true,
          label: this.$t("user-management.username"),
        },
        {
          key: "name",
          sortable: true,
          label: this.$t("user-management.name"),
        },
        {
          key: "email",
          sortable: true,
          label: this.$t("user-management.email"),
        },
        {
          key: "role",
          sortable: true,
          label: this.$t("user-management.role"),
        },
        { key: "avatar", thClass: "d-none", tdClass: "d-none" },
        {
          key: "last_login",
          sortable: true,
          label: this.$t("user-management.last_login"),
        },
        {
          key: "created_at",
          sortable: true,
          label: this.$t("table.created_at"),
        },
        {
          key: "actions",
          class: "text-center",
          label: this.$t("table.action"),
        },
      ],
      form: {
        user: {
          username: "",
          email: "",
          password: "",
          name: "",
          role: "",
        },
        pass: {
          new_password: "",
          confirm_password: "",
        },
      },
      show: {
        new: false,
        conf: false,
      },
      submitted: false,
    };
  },
  validations: {
    form: {
      user: {
        username: { required },
        email: { required },
        name: { required },
        password: { required },
        role: { required },
      },
      pass: {
        new_password: { required },
        confirm_password: { required, sameAsPassword: sameAs("new_password") },
      },
    },
  },
  computed: {
    rows() {
      return this.tableData.length;
    },
  },
  methods: {
    getUser(type) {
      let ferr = 0;
      if (!type) {
        this.loading = true;
      }
      UserService.getAllUser()
        .then((response) => {
          if (response.status == 201) {
            let new_token = response.data.refresh_access_token;
            userService.splitToken(new_token);
            this.getUser();
            ferr = 1;
            this.$store.dispatch("notification/refreshtoken", "refresh");
          } else {
            ferr = 2;
            this.tableData = [];
            this.total_users = response.data.data.length;
            response.data.data.forEach((val, index) => {
              const data = {
                no: index + 1,
                id_user: val.id_user,
                username: val.username,
                email: val.email,
                name: val.name,
                role: val.role ?? "-",
                avatar: val.avatar ?? "",
                last_login: val.last_login ?? "-",
                created_at: this.formatDate(val.created_at),
                updated_at: this.formatDate(val.updated_at),
              };
              this.tableData.push(data);

              if (val.role == "admn") {
                this.total_admin = this.total_admin + 1;
              }
              if (val.role == "anly") {
                this.total_analys = this.total_analys + 1;
              }
              if (val.role == "verf") {
                this.total_verifikator = this.total_verifikator + 1;
              }
              this.loading = false;
            });
          }
        })
        .catch((err) => {
          if (err.response == undefined) {
            console.log("err ->> ", err);
          } else if (
            this.$store.state.notification.type === "refresh-token" &&
            err.response.status == 401
          ) {
            this.getUser();
          } else {
            if (err.response.status == 401) {
              userService.logout();
            } else {
              console.log(err);
              this.loading = false;
            }
          }
        });
    },

    addUserModal() {
      this.$bvModal.show("modal-add");
      this.form.user.username = "";
      this.form.user.email = "";
      this.form.user.name = "";
      this.form.user.role = "";
      this.form.user.password = "";
    },

    addUser(e) {
      let ferr = 0;
      this.submitted = true;
      this.$v.form.user.$touch();
      if (
        this.form.user.username == "" ||
        this.form.user.email == "" ||
        this.form.user.name == "" ||
        this.form.user.role == "" ||
        this.form.user.password == ""
      ) {
        e.preventDefault();
      } else {
        const data = {
          username: this.form.user.username,
          role: this.form.user.role,
          email: this.form.user.email,
          name: this.form.user.name,
          password: this.form.user.password,
        };
        // console.log(data);
        UserService.addUser(data)
          .then((response) => {
            if (response.status == 201) {
              let new_token = response.data.refresh_access_token;
              userService.splitToken(new_token);
              this.addUser(e);
              ferr = 1;
              this.$store.dispatch("notification/refreshtoken", "refresh");
            } else {
              ferr = 2;
              Vue.swal({
                position: "top-end",
                icon: "success",
                title: response.data.message,
                showConfirmButton: false,
                timer: 1500,
              });
              this.$bvModal.hide("modal-add");
              this.getUser("refresh");
              this.resetForm();
              this.$v.$reset();
              this.loading = false;
            }
          })
          .catch((err) => {
            if (err.response == undefined) {
              console.log("err ->> ", err);
            } else if (
              this.$store.state.notification.type === "refresh-token" &&
              err.response.status == 401
            ) {
              this.addUser();
            } else {
              if (err.response.status == 401) {
                userService.logout();
              } else {
                console.log(err);
                this.loading = false;
              }
            }
          });
      }
    },

    editUser(id_user, name, username, email, role) {
      this.$bvModal.show("modal-edit" + id_user);
      this.form.user.name = name;
      this.form.user.username = username;
      this.form.user.email = email;
      this.form.user.role = role;
    },

    updateUser(e, id) {
      let ferr = 0;
      this.submitted = true;
      this.$v.form.user.$touch();
      if (
        this.form.user.username == "" ||
        this.form.user.email == "" ||
        this.form.user.name == "" ||
        this.form.user.role == ""
      ) {
        e.preventDefault();
      } else {
        console.log(id, this.form.user);
        UserService.updateUser(id, this.form.user)
          .then((response) => {
            if (response.status == 201) {
              let new_token = response.data.refresh_access_token;
              userService.splitToken(new_token);
              this.updateUser(e, id);
              ferr = 1;
              this.$store.dispatch("notification/refreshtoken", "refresh");
            } else {
              ferr = 2;
              Vue.swal({
                position: "top-end",
                icon: "success",
                title: response.data.message,
                showConfirmButton: false,
                timer: 1500,
              });
              this.$bvModal.hide("modal-edit" + id);
              this.getUser("refresh");
              this.resetForm();
              this.$v.$reset();
            }
          })
          .catch((err) => {
            if (err.response == undefined) {
              console.log("err ->> ", err);
            } else if (
              this.$store.state.notification.type === "refresh-token" &&
              err.response.status == 401
            ) {
              this.updateUser(e, id);
            } else {
              if (err.response.status == 401) {
                userService.logout();
              } else {
                console.log(err);
              }
            }
          });
      }
    },

    deleteUser(id) {
      Swal.fire({
        title: this.$t("button.delete.modal.confirmText[0]"),
        text: this.$t("button.delete.modal.confirmText[1]"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        cancelButtonText: this.$t("button.cancel"),
        confirmButtonText: this.$t("button.deleted"),
      }).then((result) => {
        console.log("swift" + id, result.value);
        if (result.value) {
          this.delUser(id);
          // console.log('id user', id);
        }
      });
    },

    delUser(id) {
      let ferr = 0;
      UserService.deleteUser(id)
        .then((response) => {
          if (response.status == 201) {
            let new_token = response.data.refresh_access_token;
            userService.splitToken(new_token);
            this.deleteUser(id);
            ferr = 1;
            this.$store.dispatch("notification/refreshtoken", "refresh");
          } else {
            ferr = 2;
            this.getUser("refresh");
            Swal.fire({
              position: "top-end",
              icon: "success",
              title: response.data.message,
              showConfirmButton: false,
              timer: 1500,
            });
          }
        })
        .catch((err) => {
          if (err.response == undefined) {
            console.log("err ->> ", err);
          } else if (
            this.$store.state.notification.type === "refresh-token" &&
            err.response.status == 401
          ) {
            this.delUser();
          } else {
            if (err.response.status == 401) {
              userService.logout();
            } else {
              console.log(err);
            }
          }
        });
    },

    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },

    onDelete(id) {
      console.log("delete data:", id);
    },

    onView(id) {
      console.log("details data:", id);
    },

    resetForm() {
      setTimeout(() => {
        this.form.user.username = "";
        this.form.user.email = "";
        this.form.user.password = "";
        this.form.user.role = "";
        this.form.user.name = "";
        this.form.pass.new_password = "";
        this.form.pass.confirm_password = "";
      }, 2000);
    },

    formatDate(value) {
      return moment(value).format("YYYY-MM-DD, hh:mm");
    },

    getId(id) {
      return Buffer.from(id).toString("base64");
    },
  },
  mounted() {
    this.totalRows = this.items.length;
    this.getUser();
  },
};
</script>

<style>
.badge {
  border-radius: 2%;
}
.btn {
  border-radius: 7%;
}
.pagination-rounded .page-link {
  outline: none !important;
  margin: 0 2px;
  border: 1px solid #ced4da;
}
.custom-paginate-dark .page-item.disabled .page-link {
  color: #a6b0ae !important;
  background-color: #022b3a !important;
}
.custom-paginate .page-item.disabled .page-link {
  color: #a6b0ae !important;
  background-color: #eff2f7 !important;
}
</style>
